import React, { ComponentPropsWithRef, PropsWithChildren } from "react";

interface Props extends PropsWithChildren<ComponentPropsWithRef<"tr">> {
  children?: React.ReactNode;
}

const TableRow = (props: Props) => {
  return (
    <tr data-testid="table-row" {...props}>
      {props.children}
    </tr>
  );
};

export default TableRow;
